import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-12 pb-4 px-4 bg-white text-center" data-id="element-184" data-mp="2hukss24eivsx">
      <div className="max-w-4xl mx-auto" data-id="element-185" data-mp="2hw45jiqumopy">
        <p className="md:text-xs text-gray-400 tracking-wider mb-4 font-[600] font-[Figtree,_sans-serif] text-[14px]" data-id="element-186" data-mp="23vl26oxbw6u4">
          "Recurso educativo digital para docentes de Secundaria"
        </p>

        <h1 className="text-3xl md:text-5xl font-black mb-1 leading-tight tracking-tight" data-id="element-187" data-mp="2wj75rx6k3bgz">
          <span className="px-2 text-[#5B3FA0] bg-[#FFFFFF] font-[900] text-[32px]" data-id="element-188" data-mp="30l2g1r6gsz6w">
            MEGAPACK ESI SECUNDARIA
          </span>
        </h1>

        <h2 className="md:text-2xl mb-3 text-gray-800 text-[16px] font-[700]" data-id="element-189" data-mp="2mte4bp04ocqg">
          El recurso docente que te ayuda a trabajar los principales temas de
          Educación Sexual Integral durante todo el año
        </h2>

        <div className="block max-w-[600px] mx-auto mb-3" data-id="element-190" data-mp="3fgqfz44r304z">
          <img src="https://cdn.magicpatterns.com/uploads/pRtZ4NNJpC3vWeMef8iJXA/ChatGPT_Image_29_jun_2026,_12_28_03_a.m._-_Editado.png" alt="Megapack ESI Secundaria" className="w-full h-auto object-contain drop-shadow-2xl rounded-xl" data-id="element-191" data-mp="3ka347d5ip4x7" />
        </div>

        <div className="text-lg md:text-xl mb-4 text-gray-700 space-y-2 max-w-3xl mx-auto font-medium" data-id="element-192" data-mp="2p63ka8r4jqm5">
          <p className="text-[14px]" data-id="element-193" data-mp="2kdtnq9vi7saw">
            No pierdas horas buscando actividades sobre bullying,
            consentimiento, ciudadanía digital, salud mental, diversidad o
            consumo de sustancias. Con este material vas a tener todo
            organizado, listo para imprimir y preparado para trabajar los temas
            más importantes de la ESI en secundaria.
          </p>
        </div>

        <div className="flex flex-nowrap items-center justify-center gap-2 sm:gap-3 mb-5 whitespace-nowrap" data-id="element-194" data-mp="335w5xpnsngn9">
          <span className="text-gray-400 line-through font-bold text-[15px] sm:text-xl" data-id="element-195" data-mp="1ds95dv41mp80">
            ARS $39.990
          </span>
          <span className="bg-red-600 text-white font-black rounded-full px-2.5 py-1 text-[11px] sm:text-sm" data-id="element-196" data-mp="38tkz5bpj47s3">
            50% OFF
          </span>
          <span className="text-[#1E3A5F] font-black text-[24px] sm:text-4xl" style={{
          color: "#5A3FA0"
        }} data-id="element-197" data-mp="3dsxy2utod5b1">
            $19.990
          </span>
        </div>

        <div className="bg-blue-50 rounded-2xl p-5 max-w-md mx-auto border border-blue-100" data-id="element-198" data-mp="3mtm0es9phh83">
          <p className="text-lg font-black text-gray-900 mb-3" data-id="element-199" data-mp="3rsgrehhtuc3a">
            👉 Acceso inmediato y organizado
          </p>
          <div className="space-y-2 text-left" data-id="element-200" data-mp="l4e4dk2eisn">
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-201" data-mp="jt9ycmpj910">
              <span className="text-green-600 mr-2 text-lg" data-id="element-202" data-mp="5de6s1ckdwym">✔️</span> Comprás
              ahora
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-203" data-mp="ads9d3vecep9">
              <span className="text-green-600 mr-2 text-lg" data-id="element-204" data-mp="ef3xt62jatvv">✔️</span> Recibís un
              email automático
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-205" data-mp="23uentbspdqpq">
              <span className="text-green-600 mr-2 text-lg" data-id="element-206" data-mp="23sbog15nul8c">✔️</span> Accedés
              inmediatamente al material completo
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-207" data-mp="1usycn1u2dkkg">
              <span className="text-green-600 mr-2 text-lg" data-id="element-208" data-mp="1puwv4lcadtb3">✔️</span> Descargás
              o utilizás el contenido cuando lo necesites
            </p>
          </div>
        </div>
      </div>
    </section>;
}